import { ICellRendererAngularComp } from 'ag-grid-angular';
import { Component } from '@angular/core';

@Component({
  selector: 'miq-ag-table-cell',
  template: `
    <span class="agtable-cell">
      {{ data | dataCellFormatter: colDef : refreshFlag }}
    </span>
  `,
  styleUrls: ['./ag-table.component.scss'],
  standalone: false,
})
export class AgTableCellRendererComponent implements ICellRendererAngularComp {
  public data: any;
  public colDef: any;
  // manual trigger for the pure dataCellFormatter pipe: data keeps the row's own reference (no per-cell copy),
  // so flipping this is what makes the pipe recompute on refresh().
  public refreshFlag = false;

  agInit(params: any): void {
    this.setValues(params);
  }

  refresh(params): boolean {
    this.setValues(params);
    this.refreshFlag = !this.refreshFlag;
    return true;
  }

  private setValues(params) {
    this.data = params.data;
    this.colDef = params.colDef;
    if (this.colDef.settings) {
      this.colDef.settings.value = params.getValue();
      this.colDef.settings.node = params.node;
    } else {
      this.colDef.settings = { value: params.getValue(), node: params.node };
    }
  }
}
